import React, {useEffect, useState} from 'react';
import {ArrowLeft, Calendar, CreditCard, FileText, Mail, Phone, User, X} from 'lucide-react';
import {PaymentInfo} from "../../types";
import {useBookTime} from "../bookTime/useBookTime";
import {PaymentMethodCta} from "../../subframe";
import {PaymentMethodTypes, useOrder} from "../../order/useOrder";
import {PreAuthModal} from "../../order/components/modals/preAuthModal/preAuthModal";
import {CreditCardPaymentModal} from "../../order/components/modals/creditCardPaymentModal/creditCardPaymentModal";
import {DobDatePicker} from "../../components/datePicker/DobDatePicker";
import CreditCardFormModal from "../../components/dejavoo/cardDetailsModal";


interface CustomerFormProps {
    // bookingData: Partial<BookingForm>;
    // onUpdateBooking: (updates: Partial<BookingForm>) => void;
    onBack: () => void;
    // onComplete: () => void;
}

export const CustomerForm: React.FC<CustomerFormProps> = ({
                                                              // onUpdateBooking,
                                                              onBack,
                                                              // onComplete
                                                          }) => {

    const today = new Date().toISOString().split("T")[0];
    const [isCardValidated, setIsCardValidated] = useState(false);
    const [paymentToken, setPaymentToken] = useState<string | null>(null);
    const [cardError, setCardError] = useState<string | null>(null);
    const [cardData, setCardData] = useState<any>(null);


    const { cart, account } = useBookTime();



    const {setPaymentMethod,
        paymentMethod,
        onPayWithCash,
        onPayWithCreditCard,
        onPreAuthCreditCard,
        onBook,
        consent,
        setHasAcceptedConsent,
        setIsPreAuthModalOpen,
        isPreAuthModalOpen,
        isProcessingCreditCardCharge,
        isCreditCardPaymentModalOpen,
        setIsCreditCardPaymentModalOpen

    }=useOrder()



    useEffect(() => {
        if (!account.requireCreditCardForBooking) {
            setPaymentMethod(PaymentMethodTypes.PAY_IN_PERSON)
        }

    }, [account.requireCreditCardForBooking]);

    const [formData, setFormData] = useState<any>({
        // firstName: bookingData.customerInfo?.firstName || '',
        // lastName: bookingData.customerInfo?.lastName || '',
        // email: bookingData.customerInfo?.email || '',
        // phone: bookingData.customerInfo?.phone || '',
        // dateOfBirth: bookingData.customerInfo?.dateOfBirth || '',
        // specialRequests: bookingData.customerInfo?.specialRequests || ''
        // firstName: bookingData.customerInfo?.firstName || '',
        lastName: '',
        email: '',
        phone: '',
        dateOfBirth: '',
        specialRequests: ''
    });

    const [consentForms, setConsentForms] = useState({
        // treatmentConsent: bookingData.consentForms?.treatmentConsent || false,
        // cancellationPolicy: bookingData.consentForms?.cancellationPolicy || false,
        // creditCardAuth: bookingData.consentForms?.creditCardAuth || false
        treatmentConsent:  false,
        cancellationPolicy:  false,
        creditCardAuth:  false
    });

    const [paymentInfo, setPaymentInfo] = useState<PaymentInfo>({
        cardNumber: '',
        expiryDate: '',
        cvv: '',
        billingAddress: {
            street: '',
            city: '',
            state: '',
            zipCode: ''
        }
    });

    // const [processing, setProcessing] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);
    const [showTreatmentWaiver, setShowTreatmentWaiver] = useState(false);

    const handleInputChange = (field: string, value: string) => {
        setFormData((prev:any) => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: '' }));
        }
    };

    const handleConsentChange = (field: string, checked: boolean) => {
        setConsentForms(prev => ({ ...prev, [field]: checked }));
    };


    const formatCardNumber = (value: string) => {
        const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        const matches = v.match(/\d{4,16}/g);
        const match = matches && matches[0] || '';
        const parts = [];

        for (let i = 0, len = match.length; i < len; i += 4) {
            parts.push(match.substring(i, i + 4));
        }

        if (parts.length) {
            return parts.join(' ');
        } else {
            return v;
        }
    };

    const formatExpiryDate = (value: string) => {
        const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        if (v.length >= 2) {
            return v.substring(0, 2) + '/' + v.substring(2, 4);
        }
        return v;
    };

    const handlePaymentInputChange = (field: string, value: string) => {
        if (field === 'cardNumber') {
            value = formatCardNumber(value);
        } else if (field === 'expiryDate') {
            value = formatExpiryDate(value);
        } else if (field === 'cvv') {
            value = value.replace(/[^0-9]/g, '').substring(0, 4);
        }

        if (field.includes('.')) {
            const [parent, child] = field.split('.');
            setPaymentInfo(prev => ({
                ...prev,
                [parent]: {
                    ...(prev[parent as keyof PaymentInfo] as any),
                    [child]: value
                }
            }));
        } else {
            setPaymentInfo(prev => ({ ...prev, [field]: value }));
        }
    };
    const validateForm = () => {
        const newErrors: Record<string, string> = {};

        if (!formData?.firstName?.trim()) {
            newErrors.firstName = 'First name is required';
        }

        if (!formData?.lastName?.trim()) {
            newErrors.lastName = 'Last name is required';
        }

        if (!formData?.email?.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        if (!formData?.phone?.trim()) {
            newErrors.phone = 'Phone number is required';
        }

        // Date of birth is optional

        if (account.consentEnabled &&!consentForms.treatmentConsent) {
            newErrors.treatmentConsent = 'Treatment consent is required';
        }

        if (!consentForms.cancellationPolicy) {
            newErrors.cancellationPolicy = 'Cancellation policy agreement is required';
        }

        if (account.requireCreditCardForBooking && !consentForms.creditCardAuth) {
            newErrors.creditCardAuth = 'Credit card authorization is required';
        }

        // The disabled button alone isn't enough (e.g. pressing Enter in a field still submits),
        // so never book without a validated card when the shop requires one.
        if (account.requireCreditCardForBooking && !isCardValidated) {
            newErrors.card = 'Please validate your card before booking';
            setCardError('Please validate your card before booking');
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            console.log('true',e)
            await onBook(e,cardData)
        }
        else {
            console.log('validate',validateForm())
        }
    };



    const handleCardValidationSuccess = (res: any) => {

        if (res.payment_token_id){
            setCardData(res)
            setPaymentToken(res.payment_token_id);
            setIsCardValidated(true);
            setCardError(null);
        }
        else {
            setIsCardValidated(false)
            setCardError(res.error);
        }

        // Optional: lock payment method explicitly
        setPaymentMethod(
            account.paymentProcessingType === "preauth"
                ? PaymentMethodTypes.PRE_AUTH
                : account.paymentProcessingType === "deposit"
                    ? PaymentMethodTypes.DEPOSIT
                    : PaymentMethodTypes.CREDIT_CARD
        );
    };
    const handleCardValidationError = (message: string) => {
        setIsCardValidated(false);
        setPaymentToken(null);
        setCardError(message);
    };



    const CancellationPolicyModal = () => (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-semibold text-slate-900">Cancellation Policy</h3>
                        <button
                            onClick={() => setShowCancellationPolicy(false)}
                            className="p-1 hover:bg-slate-100 rounded-full"
                        >
                            <X className="w-5 h-5 text-slate-400" />
                        </button>
                    </div>
                    <div className="prose prose-sm text-slate-700 space-y-4">
                        {account?.cancellationPolicy}
                        {/*<h4 className="font-medium text-slate-900">24-Hour Cancellation Policy</h4>*/}
                        {/*<p>*/}
                        {/*    We require at least 24 hours advance notice for all appointment cancellations or changes.*/}
                        {/*    This policy allows us to offer your appointment time to other clients who may be waiting.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Cancellation Fees</h4>*/}
                        {/*<ul className="list-disc pl-5 space-y-1">*/}
                        {/*    <li>Cancellations made 24+ hours in advance: No fee</li>*/}
                        {/*    <li>Cancellations made 12-24 hours in advance: 50% of service fee</li>*/}
                        {/*    <li>Cancellations made less than 12 hours in advance: 100% of service fee</li>*/}
                        {/*    <li>No-shows: 100% of service fee</li>*/}
                        {/*</ul>*/}

                        {/*<h4 className="font-medium text-slate-900">How to Cancel</h4>*/}
                        {/*<p>*/}
                        {/*    To cancel or reschedule your appointment, please call us at (716) 555-0123 or email*/}
                        {/*    info@broadwaybeautybar.com. Online cancellations are available through your booking confirmation email.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Emergency Situations</h4>*/}
                        {/*<p>*/}
                        {/*    We understand that emergencies happen. In cases of illness, family emergencies, or severe weather,*/}
                        {/*    we will work with you to reschedule without penalty. Please contact us as soon as possible.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Late Arrivals</h4>*/}
                        {/*<p>*/}
                        {/*    Please arrive 10 minutes before your scheduled appointment. Arrivals more than 15 minutes late*/}
                        {/*    may result in shortened treatment time or rescheduling, depending on our schedule availability.*/}
                        {/*</p>*/}
                    </div>
                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={() => setShowCancellationPolicy(false)}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    const TreatmentWaiverModal = () => (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-semibold text-slate-900">Treatment Consent & Waiver</h3>
                        <button
                            onClick={() => setShowTreatmentWaiver(false)}
                            className="p-1 hover:bg-slate-100 rounded-full"
                        >
                            <X className="w-5 h-5 text-slate-400" />
                        </button>
                    </div>
                    <div className="prose prose-sm text-slate-700 space-y-4">
                        <p>

                        {account?.waivers[0]?.waiverText}
                        </p>
                        {/*<h4 className="font-medium text-slate-900">Informed Consent</h4>*/}
                        {/*<p>*/}
                        {/*    I understand that I am receiving aesthetic treatments that may involve certain risks and potential complications.*/}
                        {/*    I have been informed of the nature of the treatment, expected results, and possible side effects.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Medical History Disclosure</h4>*/}
                        {/*<p>*/}
                        {/*    I confirm that I have disclosed all relevant medical history, current medications, allergies, and previous*/}
                        {/*    treatments. I understand that withholding this information may affect my treatment results and safety.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Treatment Risks</h4>*/}
                        {/*<p>I understand that aesthetic treatments may involve risks including but not limited to:</p>*/}
                        {/*<ul className="list-disc pl-5 space-y-1">*/}
                        {/*    <li>Temporary redness, swelling, or bruising</li>*/}
                        {/*    <li>Allergic reactions or sensitivity</li>*/}
                        {/*    <li>Infection (rare when proper aftercare is followed)</li>*/}
                        {/*    <li>Unsatisfactory results requiring additional treatments</li>*/}
                        {/*    <li>Temporary or permanent changes in skin pigmentation</li>*/}
                        {/*</ul>*/}

                        {/*<h4 className="font-medium text-slate-900">Aftercare Compliance</h4>*/}
                        {/*<p>*/}
                        {/*    I agree to follow all pre and post-treatment instructions provided by my practitioner.*/}
                        {/*    I understand that failure to follow aftercare instructions may affect my results and healing process.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Photography Consent</h4>*/}
                        {/*<p>*/}
                        {/*    I consent to before and after photographs being taken for my treatment records.*/}
                        {/*    I understand these photos will be kept confidential and used only for medical documentation unless*/}
                        {/*    I provide separate written consent for marketing purposes.*/}
                        {/*</p>*/}

                        {/*<h4 className="font-medium text-slate-900">Release of Liability</h4>*/}
                        {/*<p>*/}
                        {/*    I release Broadway Beauty Bar, its practitioners, and staff from any liability for complications*/}
                        {/*    or unsatisfactory results, provided that reasonable care and skill have been exercised in my treatment.*/}
                        {/*</p>*/}
                    </div>
                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={() => setShowTreatmentWaiver(false)}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );


    useEffect(() => {

        if (account){
            if (account?.requireCreditCardForBooking) {
                if (account?.paymentProcessingType ==='preauth') {
                    setPaymentMethod(PaymentMethodTypes.PRE_AUTH)
                }
                else if (account?.paymentProcessingType ==='deposit') {
                    setPaymentMethod(PaymentMethodTypes.DEPOSIT)
                }
                else {
                    setPaymentMethod(PaymentMethodTypes.CREDIT_CARD)
                }
            }
            else {
                setPaymentMethod(PaymentMethodTypes.PAY_IN_PERSON)
            }
        }

        console.log('payment methiod',paymentMethod)
    }, [account]);


    useEffect(() => {
        console.log('account',account)
    }, [account]);

    return (
        <div className="min-h-screen w-full bg-slate-50 flex flex-col items-center px-4 sm:px-0">
            {/* Header */}
            <div className="bg-white border-b border-slate-200 w-full">
                <div className="px-4 py-4 max-w-4xl mx-auto w-full">
                    <div className="flex items-center justify-between min-h-[44px]">
                        <button
                            onClick={onBack}
                            className="p-2 hover:bg-slate-100 rounded-lg transition-colors flex-shrink-0"
                        >
                            <ArrowLeft className="w-5 h-5 text-slate-600" />
                        </button>
                        <div className="flex-1 text-center px-4">
                            <h1 className="text-lg sm:text-xl font-semibold text-slate-900">Checkout</h1>
                            <p className="text-xs sm:text-sm text-slate-500 mt-0.5 hidden sm:block">Complete your booking</p>
                        </div>
                        <div className="w-9 flex-shrink-0"></div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="py-4 w-full max-w-4xl">
                <div className="bg-white rounded-lg border border-slate-200 p-4 sm:p-6 mx-4 sm:mx-0">
                    <div className="mb-4">
                        <p className="text-slate-600 text-sm text-center sm:text-left">Please provide your contact information to complete your booking.</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Personal Information */}
                        <div>
                            <h3 className="text-base font-semibold text-slate-900 mb-3 flex items-center justify-center sm:justify-start gap-2">
                                <User className="w-4 h-4 text-blue-600" />
                                Personal Information
                            </h3>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                        First Name *
                                    </label>
                                    <input
                                        name={'firstName'}
                                        type="text"
                                        value={formData.firstName}
                                        onChange={(e) => handleInputChange('firstName', e.target.value)}
                                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${
                                            errors.firstName ? 'border-red-500' : 'border-slate-300'
                                        }`}
                                        placeholder="Enter your first name"
                                    />
                                    {errors.firstName && (
                                        <p className="mt-1 text-xs text-red-600">{errors.firstName}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                        Last Name *
                                    </label>
                                    <input
                                        name={'lastName'}
                                        type="text"
                                        value={formData.lastName}
                                        onChange={(e) => handleInputChange('lastName', e.target.value)}
                                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${
                                            errors.lastName ? 'border-red-500' : 'border-slate-300'
                                        }`}
                                        placeholder="Enter your last name"
                                    />
                                    {errors.lastName && (
                                        <p className="mt-1 text-xs text-red-600">{errors.lastName}</p>
                                    )}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                        <Mail className="w-3 h-3 inline mr-1" />
                                        Email Address *
                                    </label>
                                    <input
                                        name={'email'}
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => handleInputChange('email', e.target.value)}
                                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${
                                            errors.email ? 'border-red-500' : 'border-slate-300'
                                        }`}
                                        placeholder="Enter your email address"
                                    />
                                    {errors.email && (
                                        <p className="mt-1 text-xs text-red-600">{errors.email}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                        <Phone className="w-3 h-3 inline mr-1" />
                                        Phone Number *
                                    </label>
                                    <input
                                        name={'phone'}
                                        type="tel"
                                        value={formData.phone}
                                        onChange={(e) => handleInputChange('phone', e.target.value)}
                                        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${
                                            errors.phone ? 'border-red-500' : 'border-slate-300'
                                        }`}
                                        placeholder="Enter your phone number"
                                    />
                                    {errors.phone && (
                                        <p className="mt-1 text-xs text-red-600">{errors.phone}</p>
                                    )}
                                </div>
                            </div>

                            <div className={'w-full'}>
                                <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                    <Calendar className="w-3 h-3 inline mr-1" />
                                    Date of Birth (Optional)
                                </label>

                                <DobDatePicker
                                    value={formData.dateOfBirth}
                                    error={!!errors.dateOfBirth}
                                    onChange={(date) =>
                                        setFormData((prev:any) => ({
                                            ...prev,
                                            dateOfBirth: date,
                                        }))
                                    }
                                    // onChange={(e) => handleInputChange("dateOfBirth", e?.toString())}
                                    // className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${
                                    //     errors.dateOfBirth ? "border-red-500" : "border-slate-300"
                                    // }`}
                                />


                                {/*<input*/}
                                {/*    name="dob"*/}
                                {/*    type="date"*/}

                                {/*    value={formData.dateOfBirth}*/}
                                {/*    max={today}   // 👈 blocks future dates*/}
                                {/*    onChange={(e) => handleInputChange("dateOfBirth", e.target.value)}*/}
                                {/*    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${*/}
                                {/*        errors.dateOfBirth ? "border-red-500" : "border-slate-300"*/}
                                {/*    }`}*/}
                                {/*/>*/}
                                {/*<input*/}

                                {/*    name={'dob'}*/}
                                {/*    type="date"*/}
                                {/*    value={formData.dateOfBirth}*/}
                                {/*    onChange={(e) => handleInputChange('dateOfBirth', e.target.value)}*/}
                                {/*    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-sm ${*/}
                                {/*        errors.dateOfBirth ? 'border-red-500' : 'border-slate-300'*/}
                                {/*    }`}*/}
                                {/*/>*/}
                                {errors.dateOfBirth && (
                                    <p className="mt-1 text-xs text-red-600">{errors.dateOfBirth}</p>
                                )}
                            </div>
                        </div>

                        {/* Special Requests */}
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1 text-center sm:text-left">
                                Special Requests (Optional)
                            </label>
                            <textarea
                                value={formData.specialRequests}
                                onChange={(e) => handleInputChange('specialRequests', e.target.value)}
                                rows={2}
                                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none text-sm"
                                placeholder="Any special requests or additional information..."
                            />
                        </div>

                        {/* Consent Forms */}
                        <div>
                            <h3 className="text-base font-semibold text-slate-900 mb-3 flex items-center justify-center sm:justify-start gap-2">
                                <FileText className="w-4 h-4 text-blue-600" />
                                Consent & Agreements
                            </h3>

                            <div className="space-y-3">
                                {account?.consentEnabled
                                    && <div className="flex items-start gap-2 text-left">
                                    <input
                                        type="checkbox"
                                        id="treatmentConsent"
                                        checked={consentForms.treatmentConsent}
                                        onChange={(e) => handleConsentChange('treatmentConsent', e.target.checked)}
                                        className="mt-0.5 w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
                                    />
                                    <label htmlFor="treatmentConsent" className="text-sm text-slate-700">
                                        <span className="font-medium">Treatment Consent *</span>
                                        <br/>
                                        I consent to the treatment and understand the risks, benefits, and aftercare
                                        instructions.
                                        <button
                                            type="button"
                                            onClick={() => setShowTreatmentWaiver(true)}
                                            className="text-blue-600 hover:underline ml-1"
                                        >
                                            View full waiver
                                        </button>
                                    </label>
                                </div>}
                                {errors.treatmentConsent && (
                                    <p className="text-xs text-red-600 ml-6">{errors.treatmentConsent}</p>
                                )}

                                <div className="flex items-start gap-2 text-left">
                                    <input
                                        type="checkbox"
                                        id="cancellationPolicy"
                                        checked={consentForms.cancellationPolicy}
                                        onChange={(e) => handleConsentChange('cancellationPolicy', e.target.checked)}
                                        className="mt-0.5 w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
                                    />
                                    <label htmlFor="cancellationPolicy" className="text-sm text-slate-700">
                                        <span className="font-medium">Cancellation Policy Agreement *</span>
                                        <br />
                                        I understand and agree to the
                                        <button
                                            type="button"
                                            onClick={() => setShowCancellationPolicy(true)}
                                            className="text-blue-600 hover:underline ml-1"
                                        >
                                            Cancellation Policy
                                        </button>
                                        . Cancellations must be made 24 hours in advance.
                                    </label>
                                </div>
                                {errors.cancellationPolicy && (
                                    <p className="text-xs text-red-600 ml-6">{errors.cancellationPolicy}</p>
                                )}

                                { account?.requireCreditCardForBooking && (
                                    <div className={'w-full'}>
                                        <div className="flex items-start gap-2 text-left">
                                            <input
                                                type="checkbox"
                                                id="creditCardAuth"
                                                checked={consentForms.creditCardAuth || false}
                                                onChange={(e) => handleConsentChange('creditCardAuth', e.target.checked)}
                                                className="mt-0.5 w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
                                            />
                                            <label htmlFor="creditCardAuth" className="text-sm text-slate-700">
                                                <span className="font-medium">Credit Card Authorization *</span>
                                                <br />
                                                I authorize {account?.name} to securely store my payment information on file for future appointments and authorize charges for services rendered, cancellation fees, and no-show fees as outlined in the policies above.
                                            </label>
                                        </div>
                                        {errors.creditCardAuth && (
                                            <p className="text-xs text-red-600 ml-6">{errors.creditCardAuth}</p>
                                        )}
                                    </div>
                                    )}


                            </div>
                        </div>

                        <div className="flex flex-col justify-center sm:justify-end pt-4 border-t border-slate-200">
                            <div className={'flex justify-start gap-2 items-center content-center pb-3'}>

                                {account?.requireCreditCardForBooking && !isCardValidated && (
                                    <div className="mt-6">
                                        <h3 className="text-base font-semibold text-slate-900 mb-3">
                                            Payment
                                        </h3>

                                        <CreditCardFormModal
                                            secretKey={account.iposAuthToken}
                                            freedomURL={process.env.REACT_APP_IPOS_FREEDOM_CREDIT_URL!}
                                            onCardValidationSuccess={handleCardValidationSuccess}
                                        />

                                        {cardError && (
                                            <p className="text-sm text-red-600 mt-2">{cardError}</p>
                                        )}
                                    </div>
                                )}

                                {/*<h3 className="text-base font-semibold text-slate-900 flex items-center justify-center sm:justify-start gap-2">*/}
                                {/*  */}
                                {/*    Available payment methods :*/}
                                {/*</h3>*/}

                                {/*{*/}
                                {/*    account?.requireCreditCardForBooking ? (*/}


                                {/*        <div className={'flex flex-col gap-2'} >*/}
                                {/*            {*/}
                                {/*                account?.paymentProcessingType ==='preauth' ?*/}
                                {/*                    <div className={'py-2'}>*/}
                                {/*                      */}
                                {/*                        <span className={'px-4 text-gray-500 max-w-md'}>*/}
                                {/*                Pre Auth using CREDIT CARD*/}
                                {/*            </span>*/}
                                {/*                        /!*<PaymentMethodCta*!/*/}
                                {/*                        /!*    icon="FeatherStore"*!/*/}
                                {/*                        /!*    text="Pre Auth using Credit Card"*!/*/}
                                {/*                        /!*    selected={paymentMethod === PaymentMethodTypes.PRE_AUTH}*!/*/}
                                {/*                        /!*    onClick={() => {*!/*/}
                                {/*                        /!*        setPaymentMethod(PaymentMethodTypes.PRE_AUTH)*!/*/}
                                {/*                        /!*        setIsPreAuthModalOpen(true)*!/*/}
                                {/*                        /!*    }*!/*/}
                                {/*                        /!*    }*!/*/}
                                {/*                        /!*//*/}

                                {/*                    </div>*/}
                                {/*                    :*/}
                                {/*                    <div className={'py-2'}>*/}
                                {/*                        /!*<span>Full payment</span>*!/*/}
                                {/*                        <span className={' px-4 text-gray-500 max-w-md'}>*/}
                                {/*                Full payment using CREDIT CARD*/}
                                {/*            </span>*/}
                                {/*                        /!*<PaymentMethodCta*!/*/}
                                {/*                        /!*    icon="FeatherStore"*!/*/}
                                {/*                        /!*    text="Full Payment Using Credit Card"*!/*/}
                                {/*                        /!*    selected={paymentMethod === PaymentMethodTypes.CREDIT_CARD}*!/*/}
                                {/*                        /!*    onClick={() => {*!/*/}
                                {/*                        /!*        setPaymentMethod(PaymentMethodTypes.CREDIT_CARD)*!/*/}
                                {/*                        /!*        setIsCreditCardPaymentModalOpen(true)*!/*/}
                                {/*                        /!*    }*!/*/}
                                {/*                        /!*    }*!/*/}
                                {/*                        /!*//*/}
                                // {/*                    </div>*/}


                                {/*            }*/}
                                {/*        </div>*/}
                                {/*    ): (*/}

                                {/*        <div className={'py-2'}>*/}
                                {/*            <span className={'px-4 rounded-lg text-gray-500 max-w-md'}> Pay In-Person*/}
                                {/*            </span>*/}

                                {/*            /!*<PaymentMethodCta*!/*/}
                                {/*            /!*    icon="FeatherStore"*!/*/}
                                {/*            /!*    text="Pay in person (Cash/Credit Card)"*!/*/}
                                {/*            /!*    selected={paymentMethod === PaymentMethodTypes.PAY_IN_PERSON}*!/*/}
                                {/*            /!*    onClick={() =>*!/*/}
                                {/*            /!*        setPaymentMethod(PaymentMethodTypes.PAY_IN_PERSON)*!/*/}
                                {/*            /!*    }*!/*/}
                                {/*            /!*//*/}
                                {/*        </div>*/}
                                {/*    )*/}
                                {/*}*/}


                            </div>

                            {/*<button*/}

                            {/*    type="submit"*/}
                            {/*    disabled={isProcessingCreditCardCharge}*/}
                            {/*    className={`px-8 py-3 sm:px-6 sm:py-2 rounded-lg font-medium transition-colors flex items-center gap-2 text-sm w-full sm:w-auto justify-center ${*/}
                            {/*        isProcessingCreditCardCharge*/}
                            {/*            ? 'bg-slate-400 text-white cursor-not-allowed'*/}
                            {/*            : 'bg-blue-600 text-white hover:bg-blue-700'*/}
                            {/*    }`}*/}
                            {/*>*/}
                            {/*    {isProcessingCreditCardCharge ? (*/}
                            {/*        <>*/}
                            {/*            <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>*/}
                            {/*            Processing...*/}
                            {/*        </>*/}
                            {/*    ) : (*/}
                            {/*        <>*/}
                            {/*            <CreditCard className="w-3 h-3" />*/}
                            {/*            Complete Booking*/}
                            {/*        </>*/}
                            {/*    )}*/}
                            {/*</button>*/}



                            <button
                                type="submit"
                                disabled={
                                    isProcessingCreditCardCharge ||
                                    (account.requireCreditCardForBooking && !isCardValidated)
                                }
                                className={`px-8 py-3 rounded-lg font-medium transition-colors flex items-center gap-2 text-sm ${
                                    isProcessingCreditCardCharge ||
                                    (account.requireCreditCardForBooking && !isCardValidated)
                                        ? "bg-slate-400 text-white cursor-not-allowed"
                                        : "bg-blue-600 text-white hover:bg-blue-700"
                                }`}
                            >
                                {isProcessingCreditCardCharge ? (
                                    <>
                                        <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                        Processing...
                                    </>
                                ) : (
                                    <>
                                        <CreditCard className="w-3 h-3" />
                                        Complete Booking
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


            {isPreAuthModalOpen && (
                <PreAuthModal
                    setIsPreAuthModalOpen={setIsPreAuthModalOpen}
                    isProcessingCreditCardCharge={isProcessingCreditCardCharge}
                    onPreAuthCreditCard={onPreAuthCreditCard}
                />
            )}

            {
                isCreditCardPaymentModalOpen && (
                    <CreditCardPaymentModal
                        setIsCreditCardPaymentModalOpen={
                            setIsCreditCardPaymentModalOpen
                        }
                        isProcessingCreditCardCharge={isProcessingCreditCardCharge}
                        onPayWithCreditCard={onPayWithCreditCard}
                    />
                )

            }
            {/*<div className="flex absolute h-full w-[600px] mobile:w-full z-10 top-0">*/}
            {/*    /!*<div className="bg-neutral-300/80 w-[600px] left-0 bottom-0 rounded-b-lg top-4 h-full mobile:w-full items-center" />*!/*/}
            {/*    */}
            {/*</div>*/}


            {/* Modals */}
            {showCancellationPolicy && <CancellationPolicyModal />}
            {showTreatmentWaiver && <TreatmentWaiverModal />}
        </div>
    );
};
